import a from "./isObject.js";
import i from "./_isPrototype.js";
import n from "./_nativeKeysIn.js";
var e = Object.prototype, p = e.hasOwnProperty;
function v(r) {
  if (!a(r))
    return n(r);
  var s = i(r), o = [];
  for (var t in r)
    t == "constructor" && (s || !p.call(r, t)) || o.push(t);
  return o;
}
export {
  v as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseKeysIn.js
// module id = 1437
// module chunks = 41